// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"d6fdedf4","363":"d6fdedf4","447":"d6fdedf4","494":"d6fdedf4","648":"d6fdedf4","803":"d6fdedf4","841":"d6fdedf4","979":"d6fdedf4"}[chunkId] + ".chunk.css";
};